import type React from 'react'
import { useIsMobile } from '../../hooks/useIsMobile'
import { NavigationDesktop } from '../NavigationDesktop/NavigationDesktop'
import { LayoutWrapper, FullLayout } from './HeaderLayout.styled'
import { MobileHeader } from '../MobileNavigation/components/MobileHeader'

export const HeaderLayout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { isMobile } = useIsMobile()

  return (
    <>
      {isMobile ? (
        <LayoutWrapper className="layout-wrapper">
          <MobileHeader />
          {children}
        </LayoutWrapper>
      ) : (
        <LayoutWrapper className="layout-wrapper">
          <NavigationDesktop />
          <FullLayout>{children}</FullLayout>
        </LayoutWrapper>
      )}
    </>
  )
}
